import type { Product } from '../data/products';

type ProductCardProps = {
  product: Product;
  index: number;
};

export function ProductCard({ product, index }: ProductCardProps) {
  return (
    <article className="product-card">
      <div className="product-media" aria-hidden="true">
        <img src={product.asset} alt="" />
        <span>{String(index + 1).padStart(2, '0')}</span>
      </div>
      <div className="product-copy">
        <p className="signal-label">{product.status}</p>
        <h3>{product.name}</h3>
        <strong>{product.tagline}</strong>
        <p>{product.description}</p>
        {product.href ? <a className="product-link" href={product.href}>Product details</a> : null}
      </div>
    </article>
  );
}
